import React  from 'react';
import "./Footer.css";

const FollowUs = React.memo(props => {
    return ( 
        <div className="followUsWrap">
                  {/* <div className={onlyOneMuseum?"hideSingleMuseumDD":"buttonsFormContact"}  > */}

            {((props.data.MODSiteFacebook) || (props.data.MODSiteInstgram) || (props.data.MODSiteInstgram)) &&<div className="folowUsText hidden-md-down">{props.engFooterLang?"Follow us": "עקבו אחרינו"}</div>}
            {props.sitesNotUnit && <div className="folowUsText folowUsTextTablet hidden-lg-up">{props.engFooterLang?"Follow us": "עקבו אחרינו"}</div>}

            <div className="contactUsFooter">
            {(props.data.MODSiteFacebook) &&
                <a target="_blank" rel="noopener noreferrer" href={props.data.MODSiteFacebook} title="facebook">
                    <span className="fa-stack fa-md">
                        <i className="fas fa-circle fa-stack-2x"></i>
                        <i className={props.data.MODSiteFacebookIcon+' fa-stack-1x siteText'}></i>
                    </span>
                </a>}
                {(props.data.MODSiteInstgram) &&
                    <a target="_blank" rel="noopener noreferrer" href={props.data.MODSiteInstgram} title="Instagrem">
                        <span className="fa-stack fa-md">
                            <i className="fas fa-circle fa-stack-2x"></i>
                            <i className={props.data.MODSiteInstgramIcon+' fa-stack-1x siteText'}></i>
                        </span>
                    </a>}
                {(props.data.MODSiteBlog) &&
                    <a target="_blank" rel="noopener noreferrer" href={props.data.MODSiteBlog} title="Blog">
                        <span className="fa-stack fa-md">
                            <i className="fas fa-circle fa-stack-2x"></i>
                            <i className={props.data.MODSiteBlogIcon+' fa-stack-1x siteText'}></i>
                        </span>
                    </a>}
                <a target="_blank" rel="noopener noreferrer" href={"mailto:"+props.data.MODSiteMail} title={props.data.MODSiteMail}>
                    <span className="fa-stack fa-md">
                        <i className="fas fa-circle fa-stack-2x"></i>
                        <i className='fas fa-envelope fa-stack-1x siteText'></i>
                    </span>
                </a>
            </div>
        </div>
    );
});
    export default FollowUs;